import { render, staticRenderFns } from "./BaseUser.vue?vue&type=template&id=754efdc3&"
import script from "./BaseUser.vue?vue&type=script&lang=js&"
export * from "./BaseUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports